import { cn } from '@/lib/utils';

export default function TextSmall({
    children,
    className,
}: {
    children: string;
    className?: string;
}) {
    return <span className={cn('text-sm font-normal', className)}>{children}</span>;
}
